const collegeExam = () => import('@/pages/collegeExam/index.vue');
export default [
  {
    path: '/collegeExam',
    name: 'collegeExam',
    component: collegeExam,
  },
];
